import { useContext, useEffect, useState } from "react";
import { DataContext } from "../../context/DataContext";
import { SelectionContext } from "../../context/SelectionContext";

const BookingPreviewItemLogic = (day, totalElements, index) => {
  const { bookingStatus, setBookingStatus } =
    useContext(SelectionContext);

  const { facilitiesData, setSelectedDate } = useContext(DataContext);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("");

  const manageLoader = (index) => {
    setTimeout(() => {
      setStatus(
        bookingStatus?.results?.find((val) => val.Date.split("T")[0] === day)
          ?.Status
      );
      setLoading(false);
      if (totalElements === index + 1) {
        const failureStatus = bookingStatus.results.some(
          ({ Status }) => Status === "failure"
        );

        setBookingStatus({
          status: failureStatus ? "failure" : "success",
        });
      }
    }, index * 1000);
  };

  const handleFailureIconClick = () => {
    setSelectedDate(day);
    setBookingStatus(null);
  };

  useEffect(() => {
    if (bookingStatus.status === "after-response") {
      manageLoader(index);
    }
  }, [bookingStatus]);

  return {
    handleFailureIconClick,
    facilitiesData,
    loading,
    status,
  };
};

export default BookingPreviewItemLogic;
